import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Non-autoplay logo sliders still use Swiper with prev/next buttons
$('.logo-slider .swiper').each(function() {
	const el = $(this);

	const config = {
		loop: true,
		loopAdditionalSlides: 4,
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 30
			},
			780: {
				slidesPerView: 4,
				spaceBetween: 40
			}
		}
	};

	const slider = new Swiper(this, config);

	el.siblings('.next').on('click', function(e) {
		e.preventDefault();
		slider.slideNext();
	});

	el.siblings('.prev').on('click', function(e) {
		e.preventDefault();
		slider.slidePrev();
	});
});
